module.exports = {"421024100":"资市镇","421024102":"熊河镇","421024103":"白马寺镇","421024104":"沙岗镇","421024105":"普济镇","421024106":"郝穴镇","421024200":"马家寨乡","421024201":"秦市乡","421024450":"江北监狱","421024500":"三湖管理区","421024501":"六合垸管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421024.json
// module id = 1767
// module chunks = 0